<script>
import { authComputed, authMethods } from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  props: {
    isCondensed: {
      type: Boolean,
      required: false
    },
    toggleMenu: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...authComputed,
    getMenu: function () {
      return this.$store.state.auth.currentSession ? this.$store.state.auth.currentSession.user.app_sections_tree : []
    }
  },
  mounted: function() {
    var menuRef = new MetisMenu('#side-menu',{
      activeClass: 'mm-active',
      toggle: false
    })
    menuRef.update()

    // fix to toggleMenu at menu items click
    document.querySelectorAll('.link-active').forEach(item => {
      item.addEventListener('click', event => {
        this.toggleMenu()
      })
    })
  },
  created: function() {
    if (this.loggedIn){
      this.setUserActiveSection(this.$route.path)
    }
  },
  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu"  class="metismenu">
      <li v-for="(entry, index) in getMenu" :id="`first-lv-${index}-${entry.id}`" :key="isCondensed + index" :class="{ 'mm-active ': entry.children ? entry.children.filter((x) => x.path === $route.path ).length > 0 && !isCondensed : false }" >
        <router-link v-if="'path' in entry && entry.path"  tag="a" :to=" { path: entry.path }"  class="link-active" :class="{ active: entry.path === $route.path }" :aria-expanded="false"  >
          <FontAwesomeIcon fixed-width :icon="entry.icon_name || 'arrow-right'" />
          <span> {{ entry.name }}</span>
          <span v-if="entry.children" class="menu-arrow"></span>
        </router-link>
        <a v-else  href="javascript: void(0);" :aria-expanded="false">
          <FontAwesomeIcon fixed-width :icon="entry.icon_name || 'arrow-right'" />
          <span> {{ entry.name }}</span>
          <span v-if="entry.children" class="menu-arrow"></span>
        </a>
        <!-- <b-tooltip v-if="'hover_text' in entry && entry.hover_text" :target="`first-lv-${index}-${entry.id}`" placement="top" variant="primary">
          {{ entry.hover_text }}
        </b-tooltip> -->
        <!-- if menu entry has children -->
        <ul v-if="entry.children" class="nav-second-level nav" :class="{ 'mm-show ': entry.children.filter((x) => x.path === $route.path ).length > 0 && !isCondensed }">
          <li v-for="(childsecondlv, chsecondlvidx) in entry.children" :id="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" :key="isCondensed + chsecondlvidx" :class="{ 'mm-show': childsecondlv.children ? childsecondlv.children.filter((x) => x.path === $route.path ) && !isCondensed : false }">
            <router-link v-if="'path' in childsecondlv && childsecondlv.path" tag="a" :to="{ path: childsecondlv.path }" class="link-active" :class="{ active: childsecondlv.path === $route.path }" >
              <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'arrow-right'" />
              <span> {{ childsecondlv.name }}</span>
            </router-link>
            <a v-else href="javascript: void(0);">
              <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'arrow-right'" />
              <span> {{ childsecondlv.name }} </span>
              <span v-if="childsecondlv.children" class="menu-arrow"></span>
            </a>
            <!-- <b-tooltip v-if="'hover_text' in childsecondlv && childsecondlv.hover_text" :target="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" placement="right" variant="primary">
              {{ childsecondlv.hover_text }}
            </b-tooltip> -->
            <!-- if children of menu entry has more children 3rd level max -->
            <ul v-if="childsecondlv.children" class="nav-third-level nav" >
              <li v-for="(childthirdlv, chthirdlvidx) in childsecondlv.children" :id="`third-lv-${chthirdlvidx}-${entry.id}-${childsecondlv.id}`" :key="isCondensed + chthirdlvidx" >
                <router-link v-if="'path' in childthirdlv && childthirdlv.path" tag="a" :to="{ path: childthirdlv.path }" class="link-active" :class="{ active: childsecondlv.path === $route.path }">
                  <FontAwesomeIcon fixed-width :icon="childthirdlv.icon_name || 'arrow-right'" />
                  <span> {{ childthirdlv.name }} </span>
                </router-link>
                <a v-else  href="javascript: void(0);">
                  <FontAwesomeIcon fixed-width :icon="childthirdlv.icon_name || 'arrow-right'" />
                  <span> {{ childthirdlv.name }} </span>
                </a>
                <!-- <b-tooltip v-if="'hover_text' in childthirdlv && childthirdlv.hover_text" :target="`third-lv-${chthirdlvidx}-${entry.id}-${childsecondlv.id}`" placement="right" variant="primary">
                  {{ childthirdlv.hover_text }}
                </b-tooltip> -->
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
